export default __webpack_public_path__ + "static/assets/9e7a8bf737637a20dacd17c7b55b6c39.png";